import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup } from 'reactstrap';
import { RiEditLine, RiDeleteBinLine, RiMore2Line } from 'react-icons/ri';
import { AdminRegionInfoDto } from '@repo/common-types';

interface RegionQuickActionsProps {
  region: AdminRegionInfoDto;
  onEdit: () => void;
  onDelete: () => void;
}

const RegionQuickActions: React.FC<RegionQuickActionsProps> = ({ region, onEdit, onDelete }) => {
  return (
    <ButtonGroup>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          type="button"
          aria-label={`More actions for region ${region.name}`}
          className="btn btn-sm d-flex align-items-center justify-content-center"
          style={{ minWidth: '32px', padding: '4px 8px' }}
        >
          <RiMore2Line size={16} />
        </DropdownToggle>
        <DropdownMenu start container="body">
          <DropdownItem onClick={onEdit}>
            <RiEditLine className="me-2" />
            Edit Region
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={onDelete} className="text-danger">
            <RiDeleteBinLine className="me-2" />
            Delete Region
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </ButtonGroup>
  );
};

export default RegionQuickActions;
